// extracted by mini-css-extract-plugin
export var disabled = "_1p-a";
export var hierarchyLinkGray = "_1p-4";
export var hierarchyLinkUnderline = "_1p-3";
export var hierarchyPrimary = "_1p-0";
export var hierarchySecondary = "_1p-1";
export var hierarchyTertiary = "_1p-2";
export var pressed = "_1p-6";
export var themeAction = "_1p-5";
export var themeDestructive = "_1p-8";
export var themeNormal = "_1p-7";
export var themeSuccess = "_1p-9";